import React from "react";
import Header from "../../layout/Header/Header";
import Footer from "../../layout/Footer/Footer";
import MostrarOptimo from "../Mostrar/MostrarOptimo";
import imagenes from "../../assets/Imagenes";
import WhatsAppButton from "../../components/BtnWhatsapp/Whatsapp";
import "../../styles/index.css"


const Quintas = () => {
	return (
		<>
			<Header />
			<section className="section-todas-pesnias">
			<img src={imagenes.op7} className="banner-todas-pestanias" alt="" />
			</section>

			<h1 className="titulo-h1">Quintas</h1>
			<MostrarOptimo tipo="quintas"/>
			<Footer />
		
		</>
	);
};

export default Quintas;
